import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { f as finalizeRjObject, m as mergeRjObject, c as createRjObject, S as SUCCESS, F as FAILURE, P as PENDING, R as RJ_CONFIGURED_EFFECT_CALLER, g as get, i as isEffectAction, I as INIT, a as isObjectRj } from './rjPlugin.es.js';
export { p as CANCEL, C as CLEAN, F as FAILURE, I as INIT, P as PENDING, o as RUN, S as SUCCESS, U as UPDATE_DATA, d as actionMap, a as isObjectRj, v as isPluginRj, u as isRjConfiguredCaller, b as makeEffectAction, q as makeMutationType, s as matchMutationType, r as rjPlugin, j as takeEffectConcatLatest, e as takeEffectEvery, h as takeEffectExhaust, k as takeEffectGroupBy, n as takeEffectGroupByConcatLatest, l as takeEffectGroupByExhaust, t as takeEffectLatest } from './rjPlugin.es.js';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { del } from 'object-path-immutable';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import React, { useRef, useReducer, useEffect, useContext, useDebugValue, useMemo, useState } from 'react';
import { ReplaySubject } from 'rxjs';
import { publish } from 'rxjs/operators';
import { A as AllRjEventsSubject, R as RJ_INIT_EVENT, a as RJ_DISPATCH_EVENT, b as RJ_ERROR_EVENT, c as RJ_TEARDOWN_EVENT } from './debugger.es.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import hoistStatics from 'hoist-non-react-statics';
import '@babel/runtime/helpers/esm/toArray';
import '@babel/runtime/helpers/esm/typeof';

function rjEffectBuilder(mergeObj, computed, mutations) {
  return {
    effect: function effect(configOrEffect) {
      if (typeof configOrEffect === 'function') {
        return finalizeRjObject({
          effect: configOrEffect,
          computed: computed,
          mutations: mutations
        }, mergeObj);
      }

      var name = configOrEffect.name,
          effect = configOrEffect.effect,
          sideEffectConfig = _objectWithoutProperties(configOrEffect, ["name", "effect"]);

      var mergeObjWithEffect = mergeRjObject(sideEffectConfig, mergeObj);
      return finalizeRjObject({
        name: name,
        effect: effect,
        computed: computed,
        mutations: mutations
      }, mergeObjWithEffect);
    }
  };
}

function rjComputedBuilder(mergeObj, mutations) {
  return _objectSpread(_objectSpread({}, rjEffectBuilder(mergeObj, undefined, mutations)), {}, {
    computed: function (_computed) {
      function computed(_x) {
        return _computed.apply(this, arguments);
      }

      computed.toString = function () {
        return _computed.toString();
      };

      return computed;
    }(function (computed) {
      return rjEffectBuilder(mergeObj, computed, mutations);
    })
  });
}

function rjSelectorsBuilder(mergeObj, mutations) {
  return _objectSpread(_objectSpread({}, rjComputedBuilder(mergeObj, mutations)), {}, {
    selectors: function (_selectors) {
      function selectors(_x2) {
        return _selectors.apply(this, arguments);
      }

      selectors.toString = function () {
        return _selectors.toString();
      };

      return selectors;
    }(function (selectors) {
      return rjSelectorsBuilder(mergeRjObject({
        selectors: selectors
      }, mergeObj), mutations);
    })
  });
}

function rjMutationsBuilder(mergeObj) {
  return _objectSpread(_objectSpread({}, rjSelectorsBuilder(mergeObj)), {}, {
    mutations: function (_mutations) {
      function mutations(_x3) {
        return _mutations.apply(this, arguments);
      }

      mutations.toString = function () {
        return _mutations.toString();
      };

      return mutations;
    }(function (mutations) {
      return rjSelectorsBuilder(mergeObj, mutations);
    })
  });
}

function rjConfigBuilder(mergeObj) {
  return _objectSpread(_objectSpread({}, rjMutationsBuilder(mergeObj)), {}, {
    reducer: function (_reducer) {
      function reducer(_x4) {
        return _reducer.apply(this, arguments);
      }

      reducer.toString = function () {
        return _reducer.toString();
      };

      return reducer;
    }(function (reducer) {
      return rjConfigBuilder(mergeRjObject({
        reducer: reducer
      }, mergeObj));
    }),
    composeReducer: function (_composeReducer) {
      function composeReducer(_x5) {
        return _composeReducer.apply(this, arguments);
      }

      composeReducer.toString = function () {
        return _composeReducer.toString();
      };

      return composeReducer;
    }(function (composeReducer) {
      return rjConfigBuilder(mergeRjObject({
        composeReducer: composeReducer
      }, mergeObj));
    }),
    combineReducers: function (_combineReducers) {
      function combineReducers(_x6) {
        return _combineReducers.apply(this, arguments);
      }

      combineReducers.toString = function () {
        return _combineReducers.toString();
      };

      return combineReducers;
    }(function (combineReducers) {
      return rjConfigBuilder(mergeRjObject({
        combineReducers: combineReducers
      }, mergeObj));
    }),
    actions: function (_actions) {
      function actions(_x7) {
        return _actions.apply(this, arguments);
      }

      actions.toString = function () {
        return _actions.toString();
      };

      return actions;
    }(function (actions) {
      return rjConfigBuilder(mergeRjObject({
        actions: actions
      }, mergeObj));
    })
  });
}

function rjBuilder() {
  var mergeObj = createRjObject();
  return _objectSpread(_objectSpread({}, rjConfigBuilder(mergeObj)), {}, {
    plugins: function plugins() {
      for (var _len = arguments.length, pluginsList = new Array(_len), _key = 0; _key < _len; _key++) {
        pluginsList[_key] = arguments[_key];
      }

      var withPluginsMergeObj = pluginsList.reduce(function (mergeRjObj, plugin) {
        return plugin(mergeRjObj);
      }, mergeObj);
      return rjConfigBuilder(withPluginsMergeObj);
    }
  });
}

function singleMutationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    pending: false,
    error: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PENDING:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        pending: true
      });

    case FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        pending: false
      });

    case SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        pending: false
      });

    default:
      return state;
  }
}

function singleMutation(mutationConfig) {
  return _objectSpread({
    reducer: singleMutationReducer,
    takeEffect: 'exhaust'
  }, mutationConfig);
}

function makeMultiMutationReducer(makeKey) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      pendings: {},
      errors: {}
    };
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case PENDING:
        {
          var key = makeKey.apply(void 0, _toConsumableArray(action.meta.params));
          return {
            errors: del(state.errors, key),
            pendings: _objectSpread(_objectSpread({}, state.pendings), {}, _defineProperty({}, key, true))
          };
        }

      case FAILURE:
        {
          var _key = makeKey.apply(void 0, _toConsumableArray(action.meta.params));

          return {
            errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, _key, action.payload)),
            pendings: del(state.pendings, _key)
          };
        }

      case SUCCESS:
        {
          var _key2 = makeKey.apply(void 0, _toConsumableArray(action.meta.params));

          return _objectSpread(_objectSpread({}, state), {}, {
            pendings: del(state.pendings, _key2)
          });
        }

      default:
        return state;
    }
  };
}

function multi(makeKey, mutationConfig) {
  return _objectSpread({
    reducer: makeMultiMutationReducer(makeKey),
    takeEffect: ['groupByExhaust', function (action) {
      return makeKey.apply(void 0, _toConsumableArray(action.meta.params));
    }]
  }, mutationConfig);
}

var stadanrdMutations = {
  /**
   * The shortcat to handle a mutation and track a single effect state at time.
   * Default use `'exhaust'` as `takeEffect`.
   */
  single: singleMutation,
  multi: multi
};

function rj() {
  for (var _len = arguments.length, configOrEffectAndPlugins = new Array(_len), _key = 0; _key < _len; _key++) {
    configOrEffectAndPlugins[_key] = arguments[_key];
  }

  if (configOrEffectAndPlugins.length === 0) {
    return rjBuilder();
  }

  var _ref = configOrEffectAndPlugins.slice(-1),
      _ref2 = _slicedToArray(_ref, 1),
      configOrEffect = _ref2[0];

  var config = typeof configOrEffect === 'function' ? {
    effect: configOrEffect
  } : configOrEffect;
  var plugins = configOrEffectAndPlugins.slice(0, -1);
  var emptyRjObject = createRjObject();
  var withPluginsRjObject = plugins.reduce(function (mergeRjObj, plugin) {
    return plugin(mergeRjObj);
  }, emptyRjObject);
  var withConfigAndPluginsRjObject = mergeRjObject(config, withPluginsRjObject);
  return finalizeRjObject(config, withConfigAndPluginsRjObject);
}

rj.configured = function () {
  return RJ_CONFIGURED_EFFECT_CALLER;
};

rj.mutation = stadanrdMutations;

// ~~ prince of saint felix ~~ (with types)
// Ok, types not so cool for now but for now are ok maybe improve later
var DefaultConfig = {
  shouldRun: true,
  metaOnMount: false,
  skipRunValue: false,
  meta: {}
};
var DeBp = /*#__PURE__*/function () {
  function DeBp(value) {
    var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DeBp);

    var config = _objectSpread(_objectSpread({}, DefaultConfig), c);

    this._value = value;
    this._meta = config.meta;
    this._shouldRun = config.shouldRun;
    this._metaOnMount = config.metaOnMount;
    this._skipRunValue = config.skipRunValue;
  }

  _createClass(DeBp, [{
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
  }, {
    key: "metaOnMount",
    value: function metaOnMount() {
      return this._metaOnMount;
    }
  }, {
    key: "skipRunValue",
    value: function skipRunValue() {
      return this._skipRunValue;
    }
  }, {
    key: "shouldRun",
    value: function shouldRun() {
      return this._shouldRun;
    }
  }, {
    key: "withMeta",
    value: function withMeta(newMeta) {
      this._meta = _objectSpread(_objectSpread({}, this._meta), newMeta);
      return this;
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      var onMount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // When we are on mount and meta are only 4 mount give undef
      if (!onMount && this._metaOnMount) {
        return undefined;
      }

      return this._meta;
    }
  }]);

  return DeBp;
}();
function ifDep(a, cbTrue, cbFalse) {
  return a instanceof DeBp ? cbTrue() : cbFalse();
}
var RunDeBp = function RunDeBp(a) {
  return ifDep(a, function () {
    return new DeBp(a.getValue(), {
      shouldRun: true,
      meta: a.getMeta(),
      metaOnMount: a.metaOnMount(),
      skipRunValue: a.skipRunValue()
    });
  }, function () {
    return new DeBp(a, {
      shouldRun: true
    });
  });
};
var NotRunDeBp = function NotRunDeBp(a) {
  return ifDep(a, function () {
    return new DeBp(a.getValue(), {
      shouldRun: false,
      meta: a.getMeta(),
      metaOnMount: a.metaOnMount(),
      skipRunValue: a.skipRunValue()
    });
  }, function () {
    return new DeBp(a, {
      shouldRun: false
    });
  });
};
var WithMetaDeBp = function WithMetaDeBp(a, meta) {
  return ifDep(a, function () {
    return new DeBp(a.getValue(), {
      shouldRun: a.shouldRun(),
      meta: _objectSpread(_objectSpread({}, a.getMeta()), meta)
    });
  }, function () {
    return new DeBp(a, {
      shouldRun: true,
      meta: meta
    });
  });
};
var WithMetaOnMountDeBp = function WithMetaOnMountDeBp(meta) {
  return new DeBp(true, {
    shouldRun: true,
    meta: meta,
    metaOnMount: true,
    skipRunValue: true
  });
};
var WithAlwaysMeta = function WithAlwaysMeta(meta) {
  return new DeBp(true, {
    shouldRun: true,
    meta: meta,
    metaOnMount: false,
    skipRunValue: true
  });
};
var getDepValue = function getDepValue(a) {
  return ifDep(a, function () {
    return a.getValue();
  }, function () {
    return a;
  });
};
var getDepMeta = function getDepMeta(a, onMount) {
  return ifDep(a, function () {
    return a.getMeta(onMount);
  }, function () {
    return undefined;
  });
};
var shouldDepRun = function shouldDepRun(a) {
  return ifDep(a, function () {
    return a.shouldRun();
  }, function () {
    return true;
  });
};

// ~D3BpS~
// Add meta when arg change
var withMeta = function withMeta(a, meta) {
  return WithMetaDeBp(a, meta);
}; // Add meta only on mount

var withMetaOnMount = function withMetaOnMount(meta) {
  return WithMetaOnMountDeBp(meta);
}; // Add always meta

var withAlwaysMeta = function withAlwaysMeta(meta) {
  return WithAlwaysMeta(meta);
}; // // Maybe run based on value

var maybe = function maybe(a) {
  return getDepValue(a) ? RunDeBp(a) : NotRunDeBp(a);
}; // Make all deps a maybe value!

var allMaybe = function allMaybe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(maybe);
}; // maybe if value is null

var maybeNull = function maybeNull(a) {
  return getDepValue(a) === null ? NotRunDeBp(a) : RunDeBp(a);
}; // Make all deps maybe null

var allMaybeNull = function allMaybeNull() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.map(maybeNull);
}; // Value + get object path or maybe

var maybeGet = function maybeGet(a, path) {
  var obj = getDepValue(a);

  if (obj) {
    return RunDeBp(get(obj, path));
  }

  return NotRunDeBp(a);
};

var deps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  withMeta: withMeta,
  withMetaOnMount: withMetaOnMount,
  withAlwaysMeta: withAlwaysMeta,
  maybe: maybe,
  allMaybe: allMaybe,
  maybeNull: maybeNull,
  allMaybeNull: allMaybeNull,
  maybeGet: maybeGet
});

// ([...args], prevValuesFromRunValues) => Meta({})
function getMetaFromDeps(argsWithDeps) {
  var oldValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var onMount = arguments.length > 2 ? arguments[2] : undefined;

  if (oldValues === null) {
    var _useOnMount = onMount === undefined ? true // On mount (unless forced)
    : onMount; // All changes


    return argsWithDeps.reduce(function (meta, arg, i) {
      return _objectSpread(_objectSpread({}, meta), getDepMeta(argsWithDeps[i], _useOnMount));
    }, {});
  }

  var useOnMount = onMount === undefined ? false // Not on mount (unless forced)
  : onMount;
  var oldValuesLen = oldValues.length;
  return argsWithDeps.reduce(function (meta, arg, index) {
    if (index >= oldValuesLen || getDepValue(arg) !== oldValues[index]) {
      var depMeta = getDepMeta(arg, useOnMount);

      if (depMeta) {
        return _objectSpread(_objectSpread({}, meta), depMeta);
      }

      return meta;
    }

    return meta;
  }, {});
} // From run args to -> useEffect([...runValues])

function getRunValuesFromDeps(argsWithDeps) {
  return argsWithDeps.reduce(function (runValues, arg) {
    return ifDep(arg, function () {
      // Meta on mount are not handle a run value
      if (arg.skipRunValue()) {
        return runValues;
      }

      runValues.push(arg.getValue());
      return runValues;
    }, function () {
      runValues.push(arg);
      return runValues;
    });
  }, []);
} // Should run ma values?

function shouldRunDeps(argsWithDeps) {
  return !argsWithDeps.some(function (a) {
    return !shouldDepRun(a);
  });
}

function mergeCallbacks(curriedCallbacks, callbacks) {
  var mergedCallbacks = {};

  if (curriedCallbacks.onSuccess) {
    var curriedOnSuccess = curriedCallbacks.onSuccess;

    mergedCallbacks.onSuccess = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      curriedOnSuccess.concat(callbacks.onSuccess || []).forEach(function (cb) {
        cb.apply(void 0, args);
      });
    };
  } else if (callbacks.onSuccess) {
    mergedCallbacks.onSuccess = callbacks.onSuccess;
  }

  if (curriedCallbacks.onFailure) {
    var curriedOnFailure = curriedCallbacks.onFailure;

    mergedCallbacks.onFailure = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      curriedOnFailure.concat(callbacks.onFailure || []).forEach(function (cb) {
        cb.apply(void 0, args);
      });
    };
  } else if (callbacks.onFailure) {
    mergedCallbacks.onFailure = callbacks.onFailure;
  }

  return mergedCallbacks;
}
/**
 * Builder pattern implementation for action creators calls
 * Its only aim is to decouple the invocation and the definition of params needed by the invocation itself
 * It is also the only way to leverage the rocketjump capabilities with full power
 */


var Builder = /*#__PURE__*/function () {
  function Builder(actionCreator, dispatch) {
    _classCallCheck(this, Builder);

    this.actionCreator = actionCreator;
    this.dispatch = dispatch;
    this.callbacks = {};
    this.metaTransforms = []; // Curry my Builder

    this.curriedCallbacks = {};
    this.curriedArgs = [];
  }

  _createClass(Builder, [{
    key: "withMeta",
    value: function withMeta(meta) {
      if (typeof meta === 'function') {
        this.metaTransforms.push(meta);
      } else {
        this.metaTransforms.push(function (oldMeta) {
          return _objectSpread(_objectSpread({}, oldMeta), meta);
        });
      }

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(callback) {
      this.callbacks.onSuccess = callback;
      return this;
    }
  }, {
    key: "onFailure",
    value: function onFailure(callback) {
      this.callbacks.onFailure = callback;
      return this;
    }
  }, {
    key: "curry",
    value: function curry() {
      var metaTransforms = _toConsumableArray(this.metaTransforms);

      var callbacks = _objectSpread({}, this.callbacks);

      var curriedCallbacks = _objectSpread({}, this.curriedCallbacks);

      for (var _len3 = arguments.length, curryArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        curryArgs[_key3] = arguments[_key3];
      }

      var nextArgs = this.curriedArgs.concat(curryArgs);

      var makeBuilder = function makeBuilder(actionCreator, dispatch) {
        var builder = new Builder(actionCreator, dispatch);
        builder.metaTransforms = metaTransforms;
        builder.callbacks = {};
        builder.curriedCallbacks = {
          onSuccess: curriedCallbacks.onSuccess || callbacks.onSuccess ? _toConsumableArray(curriedCallbacks.onSuccess || []).concat(callbacks.onSuccess || []) : undefined,
          onFailure: curriedCallbacks.onFailure || callbacks.onFailure ? _toConsumableArray(curriedCallbacks.onFailure || []).concat(callbacks.onFailure || []) : undefined
        };
        builder.curriedArgs = nextArgs;
        return builder;
      };

      var frozenBobBuilder = makeBuilder(this.actionCreator, this.dispatch);
      var boundActionCreator = frozenBobBuilder.run.bind(frozenBobBuilder);
      return attachBuilder(boundActionCreator, this.actionCreator, this.dispatch, makeBuilder);
    }
  }, {
    key: "run",
    value: function run() {
      for (var _len4 = arguments.length, argsWithDepsLocal = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        argsWithDepsLocal[_key4] = arguments[_key4];
      }

      var argsWithDeps = this.curriedArgs.concat(argsWithDepsLocal); // Deps can't be runned

      if (!shouldRunDeps(argsWithDeps)) {
        return;
      } // Squash meta into values


      var args = getRunValuesFromDeps(argsWithDeps);
      var action = this.actionCreator.apply(this, _toConsumableArray(args));

      if (isEffectAction(action)) {
        var callbacks = mergeCallbacks(this.curriedCallbacks, this.callbacks);
        action = action.extend({
          callbacks: callbacks
        }); // Apply meta from deps

        var extraMetaFromDeps = getMetaFromDeps(argsWithDeps, null, // No prev args
        false // Not on "mount"
        );
        action = action.withMeta(extraMetaFromDeps); // Apply meta from Builder .withMeta().withMeta()

        action = this.metaTransforms.reduce(function (action, transform) {
          return action.withMeta(transform);
        }, action); // Remove *magic* stuff

        delete action.extend;
        delete action.withMeta;
      }

      this.dispatch(action);
      return action;
    }
  }, {
    key: "asPromise",
    value: function asPromise() {
      var _this = this;

      for (var _len5 = arguments.length, argsLocal = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        argsLocal[_key5] = arguments[_key5];
      }

      var args = this.curriedArgs.concat(argsLocal);
      var callbacks = mergeCallbacks(this.curriedCallbacks, this.callbacks);
      return new Promise(function (resolve, reject) {
        var action = _this.actionCreator.apply(_this, _toConsumableArray(args));

        if (isEffectAction(action)) {
          action = action.extend({
            callbacks: {
              onSuccess: function onSuccess() {
                if (callbacks.onSuccess) {
                  callbacks.onSuccess.apply(callbacks, arguments);
                }

                resolve.apply(void 0, arguments);
              },
              onFailure: function onFailure() {
                if (callbacks.onFailure) {
                  callbacks.onFailure.apply(callbacks, arguments);
                }

                reject.apply(void 0, arguments);
              }
            }
          });
          action = _this.metaTransforms.reduce(function (action, transform) {
            return action.withMeta(transform);
          }, action);
          delete action.extend;
          delete action.withMeta;

          _this.dispatch(action);
        } else {
          _this.dispatch(action); // NOTE: Non effect action has no sense to be called asPromise
          // undefined here is to let TS quiete


          resolve(undefined);
        }
      });
    }
  }]);

  return Builder;
}();
/**
 * This function is used to attach a builder to an action creator
 * To attach a builder means to add some methods on the function object that reflect the builder class interface
 * in order to have a unique interface. This methods simply create a new builder and call the corresponding method
 * on the builder itself. This is necessary because directly attaching the builder logic to the action creator
 * would lead to some data being reused across advanced calls, and this is not intended to happen.
 *
 * The run method throws an exception just to give the user a nicer feedback on the error he/she would receive
 *  in case of bad invocation
 */


function attachBuilder(boundActionCreator, actionCreator, dispatch) {
  var makeBuilder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (a, d) {
    return new Builder(a, d);
  };

  boundActionCreator.onSuccess = function (callback) {
    return makeBuilder(actionCreator, dispatch).onSuccess(callback);
  };

  boundActionCreator.onFailure = function (callback) {
    return makeBuilder(actionCreator, dispatch).onFailure(callback);
  };

  boundActionCreator.withMeta = function (meta) {
    return makeBuilder(actionCreator, dispatch).withMeta(meta);
  };

  boundActionCreator.curry = function () {
    var _makeBuilder;

    return (_makeBuilder = makeBuilder(actionCreator, dispatch)).curry.apply(_makeBuilder, arguments);
  };

  boundActionCreator.run = function () {
    throw new Error('In order to do a plain call without meta, onSuccess or onFailure, just invoke the action creator, use the run method only when you leverage the builder functionalities');
  };

  boundActionCreator.asPromise = function () {
    var _makeBuilder2;

    return (_makeBuilder2 = makeBuilder(actionCreator, dispatch)).asPromise.apply(_makeBuilder2, arguments);
  };

  return boundActionCreator;
}
/**
 * Binds a single action creator to the dispatch dynamics, and returns a function able to dispatch
 *  the generated action when invoked
 *
 * An action creator provided by rocketjump will be dispatched in the context of rocketjump side effect model,
 *  while a standard plain action will be directly sent to the reducer
 *
 * Every action is attached a builder in order to allow for calling with more options
 *
 * By default, arguments passed directly to the function are sent in the `params` property of the action
 * If there is the need to attach some metadata or some callbacks to the action, the action must be dispatched
 *  using the builder. It is important to underline that the builder works only on rocketjump async actions
 *  (i.e. the predefined actions plus all the overrides obtained with the `actions` directive in configuration).
 *  If builder methods are invoked on plain actions, they'll simply have no effect.
 *
 * Hence, it is possible to dispatch an action in two ways, described by the following example (in which the action
 *  is called action)
 *
 * Basic call:
 * action(arg1, arg2, arg3, ...)
 *
 * Advanced call:
 * action
 *   .withMeta({ meta1: value1, meta2: value2 })
 *   .withMeta({ meta3 : value3 })
 *   .onSuccess(successHandler)
 *   .onFailure(failureHander)
 *   .run(arg1, arg2, arg3, ...)
 *
 * The basic call has no way to leverage `meta`, `onSuccess` or `onFailure` features provided by the library
 *
 * In the advanced call it is possible to call the three methods `withMeta`, `onSuccess` and `onFailure` in
 *  any order and even more than one time: the callbacks are overwritten, and meta transformation are stacked.
 *  It is mandatory that the last method of the call is the `run` method, which takes the
 *  arguments to be passed to the action creator. Apart from the `run` method, the advanced call must contain
 *  at least one other method among those documented here in order to be valid. In other words, the call
 *
 *  action.run(arg1, arg2, arg3)
 *
 *  is not valid in will raise an exception. It is in fact meaningless to dispatch an action in this way, since
 *  it would be semantically equivalent but more verbose with respect to the direct call action(arg1, arg2, arg3)
 *
 *  A note about meta transformations:
 *    the withMeta helper accepts either a plain object or a function. In case of function, that function will
 *    be invoked with the previous meta object as a parameter, and is expected to return the next meta object,
 *    which will overwrite the previous one. If instead it is given a plain object, its behaviour is equivalent
 *    of giving a function that spreads the object over the previous meta, and returns the result, such as
 *
 *    withMeta(obj) is equivalent to withMeta(oldMeta => ({ ...oldMeta, ...obj }))
 *
 */


function bindActionCreator(actionCreator, dispatch) {
  var out = function out() {
    for (var _len6 = arguments.length, argsWithDeps = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      argsWithDeps[_key6] = arguments[_key6];
    }

    // Deps can't be runned
    if (!shouldRunDeps(argsWithDeps)) {
      return;
    } // Squash meta into values


    var args = getRunValuesFromDeps(argsWithDeps);
    var action = actionCreator.apply(void 0, _toConsumableArray(args));

    if (isEffectAction(action)) {
      // Apply meta from deps
      var extraMetaFromDeps = getMetaFromDeps(argsWithDeps, null, // No prev args
      false // Not on "mount"
      );
      action = action.withMeta(extraMetaFromDeps);
      delete action.extend;
      delete action.withMeta;
    }

    dispatch(action);
    return action;
  };

  return attachBuilder(out, actionCreator, dispatch);
} // NOTE: Types are not quite right, cause for INFER all goodnes from
// actions creators we MIMIC action but with BuilderContract
// in reality we erase hack callbacks before sending to reducer ...
// and with Deps the callback can not be called ....
// But for now we are ok with this in future we try to improve this files


function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];
    boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
  }

  return boundActionCreators;
}

// Thanks 2 ma man @Andarist <3
function useConstant(fn) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = {
      v: fn()
    };
  }

  return ref.current.v;
}

var RjDebugEventEmitter = /*#__PURE__*/function () {
  function RjDebugEventEmitter(trackId, info) {
    _classCallCheck(this, RjDebugEventEmitter);

    this.trackId = trackId;
    this.info = info;
  }

  _createClass(RjDebugEventEmitter, [{
    key: "emit",
    value: function emit(type, payload) {
      AllRjEventsSubject.next({
        type: type,
        meta: {
          trackId: this.trackId,
          info: this.info
        },
        payload: payload
      });
    }
  }, {
    key: "onStateInitialized",
    value: function onStateInitialized(state) {
      this.emit(RJ_INIT_EVENT, {
        state: state
      });
    }
  }, {
    key: "onActionDispatched",
    value: function onActionDispatched(action, prevState, nextState) {
      this.emit(RJ_DISPATCH_EVENT, {
        action: action,
        prevState: prevState,
        nextState: nextState
      });
    }
  }, {
    key: "onError",
    value: function onError(error) {
      this.emit(RJ_ERROR_EVENT, error);
    }
  }, {
    key: "onTeardown",
    value: function onTeardown() {
      this.emit(RJ_TEARDOWN_EVENT, {});
    }
  }]);

  return RjDebugEventEmitter;
}();

var trackIdUniq = 0;
function createEmitter(info) {
  var emitter = new RjDebugEventEmitter(trackIdUniq, info);
  trackIdUniq++;
  return emitter;
} // Test utils to reset the trackIdUniq

var createEmitter$1;

if (process.env.NODE_ENV === 'production') {
  // Noop emitter
  createEmitter$1 = function createEmitter() {
    return null;
  };
} else {
  // Dev emitter
  createEmitter$1 = createEmitter;
}

var createRjDebugEmitter = createEmitter$1;

var ConfigureRjContext = /*#__PURE__*/React.createContext(null);

// A "mini" redux
// a reducer for handle state
// and the roboust rxjs to handle complex side effecs in a pure, declarative, fancy way!
function useMiniRedux(reducer, makeObservable, pipeActionStream, // debug information used as dev hints and other
debugInfo) {
  // Debug rj() \w classy (not in PROD)
  var debugEmitter = useConstant(function () {
    return createRjDebugEmitter(debugInfo);
  }); // $stateObservable
  // emits state updates (used to build the $dispatch Observable)

  var _useConstant = useConstant(function () {
    var subject = new ReplaySubject();
    var stateObservable = subject.asObservable();
    stateObservable.value = null;
    return [subject, stateObservable];
  }),
      _useConstant2 = _slicedToArray(_useConstant, 2),
      stateSubject = _useConstant2[0],
      stateObservable = _useConstant2[1]; // Init the reducer in the REDUX way
  // pass special INIT actions and undefined to our reducer


  function initReducer(initialArg) {
    var initialState = reducer(initialArg, {
      type: INIT
    });

    if (process.env.NODE_ENV === 'production') {
      return initialState;
    } else {
      // In DEV call the debug emitter
      debugEmitter.onStateInitialized(initialState); // NOTE:
      // First this mad shit happends only in DEV
      // Second the reason of this magic shit is because
      // call the reducer often than dispatch so logging the exact
      // sequence is impossible but since the purity nature of reducers
      // react call the reducer with the prev state in the exact sequence
      // and can do it based on the assumption of the purity of the reducer
      // so keeping an index in react state can helps us detect if the action
      // is alredy been dispatched and react simply re call the reducer to
      // have the state up date to render.
      // i am not to much secure of my toughts but if you back to point
      // one this stuff in only in DEV and don't change the other behaviurs
      // of how the state bheave.
      // the original ideas was from mad man Albi 1312.
      //
      // kepp a reference of current "dispatch index"
      // and the same value in reducer state

      stateObservable.__dispatchIndex = 0;
      return {
        idx: 0,
        state: initialState
      };
    }
  }

  var proxyReducer;

  if (process.env.NODE_ENV === 'production') {
    proxyReducer = reducer;
  } else {
    // Proxy the original reducer
    // This is only a way to hook into the React updates
    // and grab state and action to
    // keep a reference of current state and emits state updates on observable
    // ... and call the Rj debug hooks using for example to have
    // a clear logging of state changes between times as the redux dev tools does
    proxyReducer = function proxyReducer(prevState, action) {
      var nextState = reducer(prevState.state, action); // emitStateUpdate(nextState)
      // The reducer always update the state and remains a pure function

      var idx = prevState.idx + 1; // if the new dispatch index is greater is a new action

      if (idx > stateObservable.__dispatchIndex) {
        // Emit the debug hook
        debugEmitter.onActionDispatched(action, prevState.state, nextState); // keep the index at the last version

        stateObservable.__dispatchIndex = idx;
      } // Always update the state in the same way a pure function lol


      return {
        idx: idx,
        state: nextState
      };
    };
  }

  var _useReducer = useReducer(proxyReducer, undefined, // the first argument of reducer is undefined in the redux way
  initReducer),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      stateAndIdx = _useReducer2[0],
      dispatch = _useReducer2[1]; // Hack for x hook into react dispatch


  var state;

  if (process.env.NODE_ENV === 'production') {
    // No need in prod is directly the state
    state = stateAndIdx;
  } else {
    // Grab the piece of original state
    state = stateAndIdx.state;
  } // Emit a state update to stateObservable Observable
  // ... keep a reference of current state


  useEffect(function () {
    stateObservable.value = state;
    stateSubject.next(state);
  }, [state, stateObservable, stateSubject]);

  var _useConstant3 = useConstant(function () {
    // Why ReplaySubject?
    // in the old useMiniRedux implementation
    // subscription happened in the render phase
    // but as says ma men @bvaughn for the correct work
    // of upcoming async mode side effects are allowed 2 run
    // in the commit phase ...
    // Check this: https://github.com/facebook/react/tree/master/packages/use-subscription
    // thanks 2 ReplaySubject the action dispatched between the render and commit phase
    // are "re-played" and correct dispatched to our rx side effects or react reducer state
    var subject = new ReplaySubject();
    var actionObserable = subject.asObservable(); // Apply the effect pipeline
    // useful to change the "normal" action stream
    // ES:. here you can debounce, filter or other
    // stuff before the action trigger Y effect

    var rjPipedActionObservable = pipeActionStream(actionObserable, stateObservable) // this ensure that the side effects inside effectPipeline
    // Es: tap(() => { sideEffect() })
    // are excuted only once
    // in the older implementation this mechanism was in
    // createMakeRxObservable but this leads to a lot of bug and
    // mysterious behaviours now pubblish are excuted only once
    // in front of the original action observable
    .pipe(publish()); // Create the dispatch observable

    var dispatchObservable = makeObservable(rjPipedActionObservable, stateObservable);
    return [subject, rjPipedActionObservable, dispatchObservable];
  }),
      _useConstant4 = _slicedToArray(_useConstant3, 3),
      actionSubject = _useConstant4[0],
      actionObservable = _useConstant4[1],
      dispatchObservable = _useConstant4[2]; // Subscription 2 dispatchObservable


  useEffect(function () {
    var subscription = dispatchObservable.subscribe(function (action) {
      // Erase callbacks before dispatch on reducer
      var successCallback;

      if (action.successCallback) {
        successCallback = action.successCallback;
        delete action.successCallback;
      }

      var failureCallback;

      if (action.failureCallback) {
        failureCallback = action.failureCallback;
        delete action.failureCallback;
      } // Dispatch the cleaned action


      dispatch(action); // Run the callbacks if needed

      if (successCallback) {
        successCallback(action.payload.data);
      }

      if (failureCallback) {
        failureCallback(action.payload);
      }
    }, function (error) {
      // Detailed info about error ...
      var errorStr = 'An error occured during your effect';

      if (debugInfo.name) {
        errorStr += " located in rocketjump ".concat(debugInfo.name, ".");
      } else {
        errorStr += '.';
      }

      if (process.env.NODE_ENV !== 'production') {
        debugEmitter.onError(errorStr);
      } else {
        console.error("[react-rocketjump] ".concat(errorStr));
      }

      throw error;
    }); // Ok now we are ready to handle shit from dispatchObservable observable!

    actionObservable.connect();
    return function () {
      subscription.unsubscribe(); // Say good bye to debugger

      if (process.env.NODE_ENV !== 'production') {
        debugEmitter.onTeardown();
      }
    };
  }, [actionObservable, debugEmitter, debugInfo, dispatchObservable]); // Extra shit from <ConfigureRj />

  var extraConfig = useContext(ConfigureRjContext); // NOTE: Why not a simple useRef?
  // cause in rx we want to grab CURREN config:
  // ... so if we passed ref.current the extraConfig will
  // IMMUTABLE change instance and inside rx we will
  // get old instance on the other and if we passed
  // the React return of useRef() reading ref.current
  // on unmounted componet can be null
  // this is not a real problem if the rx handler
  // live and dead with the Component
  // but since in the upconmig cache this can be
  // true ... reading the .current of another object avoid
  // the risk of reading null cause

  var effectArgs = useConstant(function () {
    return {
      current: extraConfig
    };
  });
  useEffect(function () {
    effectArgs.current = extraConfig;
  }, [extraConfig, effectArgs]); // Dispatch to reducer or start an effect

  var dispatchWithEffect = useConstant(function () {
    return function (action) {
      if (isEffectAction(action)) {
        // Emit action to given observable theese perform side
        // effect and emit action dispatched above by subscription
        // ... Inject the a ref to current action extraConfig
        // NOTE:
        // this maintein the OLD RJ Contract
        // the configured effect caller is evalutated when the effect
        // is runner Vs when the action is dispatched
        Object.defineProperty(action, '__rjEffectRef', {
          value: effectArgs
        });
        actionSubject.next(action);
      } else {
        // Update the state \w given reducer
        dispatch(action);
      }
    };
  });
  return [state, dispatchWithEffect];
}

function useRj( // The returned value of rj(..., EFFECT)
rjObject, // A function to select state
selectState) {
  if (!isObjectRj(rjObject)) {
    throw new Error('[react-rocketjump] You should provide a rj object to useRj.');
  }

  var name = rjObject.name,
      makeObservable = rjObject.makeObservable,
      pipeActionStream = rjObject.pipeActionStream,
      actionCreators = rjObject.actionCreators,
      reducer = rjObject.reducer,
      makeSelectors = rjObject.makeSelectors,
      computeState = rjObject.computeState;
  useDebugValue(name ? "rj(".concat(name, ")") : 'Rocks'); // Rj optinal name as debug info

  var rjDebugInfo = useConstant(function () {
    return {
      name: name
    };
  });

  var _useMiniRedux = useMiniRedux(reducer, makeObservable, pipeActionStream, rjDebugInfo),
      _useMiniRedux2 = _slicedToArray(_useMiniRedux, 2),
      state = _useMiniRedux2[0],
      dispatch = _useMiniRedux2[1]; // Bind actions \w dispatch


  var boundActionCreators = useConstant(function () {
    return bindActionCreators(actionCreators, dispatch);
  }); // Create per-rj-instance memoized selectors

  var memoizedSelectors = useConstant(function () {
    return makeSelectors();
  }); // Derive the state

  var derivedState = useMemo(function () {
    var derivedState = computeState(state, memoizedSelectors);

    if (typeof selectState === 'function') {
      derivedState = selectState(state, memoizedSelectors, derivedState);
    }

    return derivedState;
  }, [state, memoizedSelectors, selectState, computeState]); // Memoize return value now can saftley used in React Context.Provider

  return useMemo(function () {
    return [derivedState, boundActionCreators];
  }, [derivedState, boundActionCreators]);
}

// Use a rocketjump and run it according to run arguments.
// This is only a syntax sugar over useRj and useEffect,
// you can create your own helper, we think this is the most "useful" version
// from our point of view.
function useRunRj(rjObject) {
  var runArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var shouldCleanOnNewEffect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var // A function to select state
  selectState = arguments.length > 3 ? arguments[3] : undefined;

  var _useRj = useRj(rjObject, selectState),
      _useRj2 = _slicedToArray(_useRj, 2),
      state = _useRj2[0],
      originalActions = _useRj2[1];

  var run = originalActions.run,
      clean = originalActions.clean;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      withMeta = _useState2[0],
      setWithMeta = _useState2[1];

  var prevWithMeta = useRef(null);
  var runValues = getRunValuesFromDeps(runArgs);
  var prevRunValues = useRef(null);
  useEffect(function () {
    // Should run?
    var shouldRun = shouldRunDeps(runArgs);

    if (shouldRun) {
      var _run$withMeta;

      var _meta = getMetaFromDeps(runArgs, prevRunValues.current); // Add meta only if setWithMeta in called along with last args update


      var hackRunWithMeta = {};

      if (prevWithMeta.current && prevWithMeta.current !== withMeta) {
        hackRunWithMeta = withMeta;
      }

      (_run$withMeta = run.withMeta(_objectSpread(_objectSpread({}, _meta), hackRunWithMeta))).run.apply(_run$withMeta, _toConsumableArray(runValues));
    }

    prevRunValues.current = runValues;
    prevWithMeta.current = withMeta;
    return function () {
      if (shouldCleanOnNewEffect && shouldRun) {
        clean();
      }
    }; // spreading run arguments as deps means:
    // every time a run arguments changes (Object.is comparison)
    // a run is triggered and (if configured) a clean to clean up
    // the old effect related state
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clean, run, shouldCleanOnNewEffect].concat(_toConsumableArray(runValues)));
  var actions = useMemo(function () {
    return _objectSpread(_objectSpread({}, originalActions), {}, {
      withNextMeta: setWithMeta
    });
  }, [setWithMeta, originalActions]);
  return useMemo(function () {
    return [state, actions];
  }, [state, actions]);
}

var defaultMapActionsToProps = function defaultMapActionsToProps(a) {
  return a;
};

function connectRj( // The returned value of rj(..., EFFECT)
rjObject, mapStateToProps) {
  var mapActionsToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMapActionsToProps;
  return function wrapWithConnect(WrappedComponent) {
    if (!isObjectRj(rjObject)) {
      throw new Error('[react-rocketjump] You should provide a rj object to connectRj.');
    }

    function ConnectFunction(props) {
      var name = rjObject.name,
          makeObservable = rjObject.makeObservable,
          pipeActionStream = rjObject.pipeActionStream,
          actionCreators = rjObject.actionCreators,
          reducer = rjObject.reducer,
          makeSelectors = rjObject.makeSelectors,
          computeState = rjObject.computeState;
      var wrappedComponentName = WrappedComponent.name;
      var rjDebugInfo = useMemo(function () {
        return {
          name: name,
          wrappedComponentName: wrappedComponentName
        };
      }, [wrappedComponentName, name]);

      var _useMiniRedux = useMiniRedux(reducer, makeObservable, pipeActionStream, rjDebugInfo),
          _useMiniRedux2 = _slicedToArray(_useMiniRedux, 2),
          state = _useMiniRedux2[0],
          dispatch = _useMiniRedux2[1];

      var memoizedSelectors = useConstant(function () {
        if (typeof mapStateToProps === 'function' || typeof computeState === 'function') {
          return makeSelectors();
        }

        return null;
      });
      var stateDerivedProps = useMemo(function () {
        var derivedState = state;

        if (typeof computeState === 'function') {
          derivedState = computeState(state, memoizedSelectors);
        }

        if (typeof mapStateToProps === 'function') {
          derivedState = mapStateToProps(state, memoizedSelectors, props, derivedState);
        }

        return derivedState;
      }, [state, memoizedSelectors, computeState, props]);
      var boundActionCreators = useMemo(function () {
        return bindActionCreators(mapActionsToProps(actionCreators), dispatch);
      }, [dispatch, actionCreators]);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, boundActionCreators, stateDerivedProps, props));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = "connectRj(".concat(wrappedComponentName, ")");
    ConnectFunction.displayName = displayName;
    var Connect = /*#__PURE__*/React.memo(ConnectFunction);
    return hoistStatics(Connect, WrappedComponent);
  };
}

// util 4 compose hocs compose(hoc1, hoc2)(Component) hoc2(hoc1(Component))
function compose() {
  for (var _len = arguments.length, hocs = new Array(_len), _key = 0; _key < _len; _key++) {
    hocs[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    return hocs.reduce(function (Component, hoc) {
      return hoc(Component);
    }, WrappedComponent);
  };
}

function ConfigureRj(_ref) {
  var children = _ref.children,
      effectCaller = _ref.effectCaller;
  var extraConfig = useMemo(function () {
    return {
      effectCaller: effectCaller
    };
  }, [effectCaller]);
  return /*#__PURE__*/React.createElement(ConfigureRjContext.Provider, {
    value: extraConfig
  }, children);
}

export { ConfigureRj, bindActionCreators, compose, connectRj, deps, rj, useRj, useRunRj };
